import React from 'react';
import CustomNavbar from '../components/CustomNavbar';
import Breadcrumb from '../components/Breadcrumb';
import PrototypeService from '../components/Service/Sservice/PrototypeService';
import FooterTwo from '../components/Footer/FooterTwo';
import Portfoliosingle from '../components/Portfolios/Portfoliosingle';
import FooterData from '../components/Footer/FooterData';

const Service = () => {
    return(
        <div className="body_wrapper">
            <CustomNavbar slogo="sticky_logo" mClass="menu_four" nClass="w_menu ml-auto mr-auto"/>
            <Breadcrumb breadcrumbClass="breadcrumb_area" imgName="breadcrumb/banner_bg.png" Ptitle="Resources" Pdescription="Pipe Hangers & Supports operates out of two locations, one at Chennai & the other at Thanjavur, Tamil Nadu (about 30 kms from BHEL - Trichy)."/>
            {/* <HRService ServiceData={ServiceData}/> */}
            
            <Portfoliosingle/>
            <PrototypeService/>
            
            <FooterTwo fClass="" FooterData={FooterData}/>
        </div>
    )
}
export default Service;